import React, { useState } from "react";
import ImageCam from "../ImageCam/ImageCam";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setSelfieModalClose,
  setUserClusterApiTrigger,
} from "../../../store/state-slices/userRegistration";
import useApiHttp from '../../../hooks/use-http'
import { Notifications } from "@jds/core";

export default function SelfieLiveliness({
  setToastOpen = () => { },
  setToastInfo = () => { },
  ...props
}) {
  const isAdmin = localStorage.getItem('isAdmin')
  const [modalOpen, setModalOpen] = useState(true);
  const [finalImage, setFinalImage] = useState(null);
  const { selfieModalClose } = useSelector((state) => state.userRegistration);
  const [camKey, setCamKey] = useState(0);

  const loginDetails = useSelector((state) => state.auth.loginDetails);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { sendRequest: updateProfile, isLoading: isProfileUpdating } =
    useApiHttp();
  const { sendRequest: getFaceCount, isLoading: isGetFaceCounting } =
    useApiHttp();

  const resetSelfie = () => {
    // setFileBlod(null);
    // setUserSelectedFile(null);
    // setIsWebcamReady(false);
    // setPreviewUrl(null);
    // setIsCropped(false);
  };

  const handleGetFaceCount = (img) => {
    const userProfile = new FormData();
    userProfile.append("uploadFile", img);
    getFaceCount(
      {
        base: "MEDIA",
        url: `face/get-face-count`,
        method: "POST",
        body: userProfile,
        formData: true,
      },
      null,
      () => {
        // setBtnDisable(true);
        if (img && props?.getFile) {
          props?.getFile(img);
        } else {
          handleUpdateSelfie(img);
        }
      },
      (err, data) => {
        if (isAdmin) {
          Notifications.toast.error({
            id: "get-face-count-error",
            title: data?.message,
          });
        }

        setToastInfo({
          msg: data?.message,
          type: "error",
        });
        setToastOpen(true);
      }
    );
  };

  const handleUpdateSelfie = (img) => {
    const userProfile = new FormData();
    userProfile.append("profilePicture", img);
    updateProfile(
      {
        base: "AUTH",
        url: `profile`,
        method: "PUT",
        body: userProfile,
        formData: true,
      },
      null,
      (data) => {
        setTimeout(() => {
          setToastInfo({
            msg: data?.message,
            type: "success",
          });
          setToastOpen(true);
          localStorage.profilePictureThumbnail =
            data?.data?.profilePictureThumbnailUrl;
          dispatch(setSelfieModalClose(true));
          dispatch(setUserClusterApiTrigger());
          !isAdmin && navigate(`/user-registered/photos?eventId=${loginDetails?.eventId}`);
          // setBtnDisable(false);
          props?.onSuccess && props.onSuccess()

          // resetSelfie();
        }, 500);
      },
      (err, data) => {
        if (isAdmin) {
          Notifications.toast.error({
            id: "update-profile",
            title: data?.message,
          });
        }
        setToastInfo({
          msg: data?.message,
          type: "error",
        });
        setToastOpen(true);
        // setBtnDisable(false);
      }
    );
  };

  return (
    <>
      {/* {!finalImage && <button onClick={() => setModalOpen(true)}>Open Liveliness</button>} */}

      {modalOpen && (
        <div className="modal">
          <ImageCam
            key={camKey}
            setCamKey={() => setCamKey(prev => prev + 1)}
            onClose={() => {
              // setModalOpen(false)
              setFinalImage(null);
              dispatch(setSelfieModalClose(true));
            }}
            isGetFaceCounting={isGetFaceCounting || isProfileUpdating}
            onCapture={(img) => {
              setFinalImage(img);
              handleGetFaceCount(img)
              // setModalOpen(false);
            }}
            skip={props?.skip}
          />
        </div>
      )}

      {/* {finalImage && (
        <div style={{ textAlign: "center", marginTop: 20 }}>
          <h3>Final Captured Image:</h3>
          <img
            src={finalImage}
            alt="captured selfie"
            style={{ width: 200, borderRadius: "50%" }}
          />
        </div>
      )} */}
    </>
  );
}
